'use client';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { useVoiceAssistant } from '@livekit/components-react';
import { useCallHistory } from './CallHistoryProvider';
export function TranscriptionPanel({ room: _room }) {
    const { transcriptLines } = useCallHistory();
    const { agent, state } = useVoiceAssistant();
    const scrollRef = useRef(null);
    useEffect(() => {
        const node = scrollRef.current;
        if (node)
            node.scrollTop = node.scrollHeight;
    }, [transcriptLines]);
    const stateLabel = agent?.identity ? state : 'connecting';
    return (_jsxs("div", { className: "flex h-full min-h-0 min-w-0 flex-col gap-3", children: [_jsxs("div", { className: "text-sm font-medium", children: ["Live call", ' ', _jsxs("span", { className: "text-muted-foreground font-normal", children: ["\u00B7 ", stateLabel] })] }), _jsx("div", { ref: scrollRef, className: "flex-1 min-h-0 divide-y divide-border/60 overflow-y-auto rounded-md border border-border bg-muted/20 px-3 py-2 text-xs", children: transcriptLines.length === 0 ? (_jsx("div", { className: "text-xs text-muted-foreground", children: "Waiting for the agent to speak\u2026" })) : (transcriptLines.map((line, idx) => (_jsxs("div", { className: idx === 0 ? 'pb-2' : 'py-2 last:pb-0', children: [_jsx("div", { className: "mb-0.5 text-[10px] font-medium uppercase tracking-wide text-muted-foreground", children: line.role === 'agent'
                                ? 'Agent'
                                : line.role === 'staff'
                                    ? 'Staff'
                                    : 'You' }), _jsx("div", { className: "break-words leading-snug", children: line.text })] }, line.key)))) })] }));
}
//# sourceMappingURL=TranscriptionPanel.js.map